import { connect } from 'react-redux';

import { GlobalState } from 'ha/types/store';
import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';

import NavBarDesktop from '../components/NavBarDesktop';

export default connect((state: GlobalState) => ({
  isAuthenticated: getIsAuthenticated(state),
}))(NavBarDesktop);
